// import Vue from 'vue'
import { Model } from '@vuex-orm/core'

export default class Composition extends Model {
  static entity = 'compositions'

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      data: this.attr({}),
      options: this.attr([]),
      isAdition: this.attr(false),
    }
  }
}
